enum ApiResource {
  Auth = 'api/auth',
  Customer = 'customer',
  Locations = 'locations',
  Orders = 'orders',
}

export { ApiResource };
